<template>
    <div class="c-gallery">
        <gallery
            :images="galleryImages"
            :index="$store.state.galleryIndex"
            @close="closeGallery()"
            @onslide="currentIndex = $event.index"
        >
            <!-- <slot ref="gallery"></slot>
            <span slot="prev">&lt;</span>
            <span slot="next">&gt;</span> -->
            <span slot="close">&times;</span>
        </gallery>
        <!-- <ion-grid
            class="c-gallery__footer"
            v-if="$store.state.galleryIndex !== null"
        >
            <ion-row class="ion-text-center">
                <ion-col>
                    <ion-button
                        size="large"
                        fill="clear"
                        shape="round"
                        @click="openDokboxShareModal()"
                    >
                        <ion-icon name="share" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button
                        size="large"
                        fill="clear"
                        shape="round"
                        @click="deleteFile()"
                    >
                        <ion-icon name="trash"></ion-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid> -->
    </div>
</template>

<script>
import VueGallery from "vue-gallery";
import { BASEURL, setBaseurl } from "@/utils/globals";
import { deleteDokboxFile } from "@/api/dokbox";
import DokboxShareModal from "./DokboxShareModal";

export default {
    components: {
        gallery: VueGallery,
    },
    data() {
        return {
            baseurl: BASEURL,
            currentIndex: null,
        };
    },
    mounted() {},
    watch: {
        baseurlServer() {
            setBaseurl(this.baseurlServer);
            this.baseurl = BASEURL;
        },
    },
    methods: {
        closeGallery() {
            this.$store.commit("setGalleryIndex", null);
            this.currentIndex = null;
        },
        deleteFile() {
            this.$ionic.alertController
                .create({
                    header: "Datei löschen",
                    message: "Möchtest du die Datei wirklich löschen?",
                    buttons: [
                        {
                            text: "Nein",
                            role: "cancel",
                        },
                        {
                            text: "Ja",
                            handler: () => {
                                this.$store.commit("setLoading", true);
                                deleteDokboxFile(
                                    this.$store.getters["dokbox/images"][
                                        this.currentIndex
                                    ].fileId
                                ).then((response) => {
                                    if (response.data.Status === 200) {
                                        this.$store.commit(
                                            "dokbox/setReset",
                                            true
                                        );
                                        this.closeGallery();
                                        this.$ionic.toastController
                                            .create({
                                                color: "dark",
                                                duration: 2000,
                                                message:
                                                    "Datei erfolgreich gelöscht",
                                                showCloseButton: true,
                                                closeButtonText: "Schließen",
                                            })
                                            .then((toast) => {
                                                toast.present();
                                            });
                                    }
                                });
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
        openDokboxShareModal() {
            this.$ionic.modalController
                .create({
                    component: DokboxShareModal,
                    componentProps: {
                        propsData: {
                            currentIndex: this.currentIndex,
                        },
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
    },
    computed: {
        galleryImages() {
            let result = [];
            for (let file of this.$store.getters["dokbox/images"]) {
                if (Capacitor.isNative && Capacitor.platform === "ios") {
                    if (this.$store.state.dokbox.base64Images[file.fileHash]) {
                        result.push(
                            this.$store.state.dokbox.base64Images[file.fileHash]
                        );
                    }
                } else {
                    result.push(
                        this.baseurl +
                            file.fileUrl +
                            "&TokenId=" +
                            this.$store.state.galleryToken
                    );
                }
            }
            return result;
        },
        baseurlServer() {
            return this.$store.state.baseurl;
        },
    },
};
</script>

<style lang="scss">
.c-gallery {
    .blueimp-gallery {
        z-index: 10000;
        background: black;
        .close {
            top: calc(15px + var(--ion-safe-area-top, 0));
            opacity: 1;
        }
        .prev,
        .next {
            display: none;
        }
        @media only screen and (min-width: $breakpoint-md) {
            .prev,
            .next {
                display: block;
            }
        }
    }
    &__footer {
        position: fixed;
        bottom: 0;
        z-index: 10001;
        left: 0;
        right: 0;
        background: black;
        padding-bottom: var(--ion-safe-area-bottom, 0);
        ion-button {
            color: white;
        }
    }
}
</style>
